// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main/css/" + chunkId + "." + {"114":"65e80fa8","127":"570e2a39","167":"5b0622bd","442":"09322128","779":"570e2a39","808":"939b49d1"}[chunkId] + ".chunk.css";
};